import { Typography } from '@mui/material';

/**
 * A plain heading inside a form layout — for a title that shares a row with
 * the first field (e.g. "New Travel Expense" next to the project picker).
 * Display only: no key, no value.
 */
const TypeHeading = ({ field }) => {
  return (
    <Typography variant={field.variant || 'h3'} className="whitespace-nowrap">
      {field.label}
    </Typography>
  );
};

export default TypeHeading;
